// The Thai table (ship 3): pet-tag's wording as it is today, character for character (ruling R18) —
// gathered from main.js, editor/session.js, editor/canvas2d.js and ui/share-ui.js, and — since the
// worker speaks codes (ruling R9) — the sentences validate.js, templates.js, generate.js, sanitize.js,
// geometry.worker.js and doc.js said, character for character (`worker`, `link`; src/worded.js says
// them). The label maps (shape, template, icon, preset, roleLabel) are the only copies there are.
const S = {
  loading: "กำลังโหลด…",
  building: "กำลังสร้างแบบ…",
  layingOut: "กำลังจัดวาง…",
  makingFile: "กำลังสร้างไฟล์…",
  timedOut: "สร้างแบบไม่เสร็จใน 10 วินาที จึงเริ่มใหม่ — ลองลดตัวอักษรหรือเปลี่ยนฟอนต์",
  loadFailed: "โหลดไม่สำเร็จ — ลองโหลดหน้านี้ใหม่",
  triangles: (n) => `${n.toLocaleString()} สามเหลี่ยม`,
  loading3d: "กำลังโหลดมุมมอง 3 มิติ…",
  load3dFailed: "เปิดมุมมอง 3 มิติไม่ได้ — ลองอีกครั้ง",
  fontLoading: (family, got, total) => (total > 0 ? `กำลังโหลด ${family} ${got} / ${total} MB` : `กำลังโหลด ${family} ${got} MB`),
  fontLinkNote: (family) => `โหลดฟอนต์ ${family} ไม่ได้ — ตรวจการเชื่อมต่อ · ใช้ฟอนต์เดิมต่อ`,
  more: (n) => `อีก ${n} รายการ`,
  placeholder: {
    name: "เช่น บิ๊ก หรือ Big",
    phone: "0812345678",
  },
  emptyEl: "(ว่าง)",
  addTitle: "เพิ่มข้อความหรือไอคอน",
  resetWarning: "การจัดวางที่ปรับเองจะถูกรีเซ็ต และชิ้นที่เพิ่มเองจะถูกลบ (กด ↶ เพื่อย้อนกลับได้)",
  hint: {
    touch: "ลากนิ้วตรงไหนก็ได้บนป้ายเพื่อเลื่อนชิ้นที่เลือก — ไม่ต้องกดทับตัวอักษร",
    mouse: "ลากชิ้นงานด้วยเมาส์ หรือใช้ปุ่มลูกศรบนคีย์บอร์ด (Shift = ทีละ 1 มม.)",
  },
  ariaPreview: {
    front: "ตัวอย่างป้าย 2 มิติ",
    back: "ตัวอย่างป้าย 2 มิติ ด้านหลัง",
  },
  iconSize: "ขนาดไอคอน",
  textSize: "ขนาดตัวอักษร",
  roleLabel: {
    name: "ชื่อ",
    phone: "เบอร์โทร",
    text: "ข้อความ",
    icon: "ไอคอน",
  },
  fieldLabel: {
    name: "ชื่อสัตว์เลี้ยง",
    phone: "เบอร์โทรศัพท์",
    text: "ข้อความ",
    icon: "ไอคอน",
  },
  face: {
    back: " (ด้านหลัง)",
  },
  copied: "คัดลอกลิงก์แล้ว — วางในแชตได้เลย",
  copyManual: "คัดลอกอัตโนมัติไม่ได้ — กดค้างที่ลิงก์ด้านบนเพื่อคัดลอก",
  shape: {
    circle: "กลม",
    bone: "กระดูก",
    heart: "หัวใจ",
    paw: "อุ้งเท้า",
    cat: "หัวแมว",
  },
  template: {
    name: "ชื่ออย่างเดียว",
    "name-phone": "ชื่อ + เบอร์โทร",
    "name-front-phone-back": "ชื่อด้านหน้า + เบอร์ด้านหลัง",
    "icon-name": "ไอคอน + ชื่อ",
    "icon-name-phone-back": "ไอคอน + ชื่อ, เบอร์ด้านหลัง",
  },
  icon: {
    paw: "อุ้งเท้า",
    heart: "หัวใจ",
    bone: "กระดูก",
    star: "ดาว",
    fish: "ปลา",
    cat: "แมว",
    dog: "หมา",
    phone: "โทรศัพท์",
  },
  preset: {
    dog: "น้องหมา",
    cat: "น้องแมว",
    paw: "อุ้งเท้า",
    heart: "หัวใจ",
  },
  engravedNote: "ตัวอักษรแบบรอยกดใช้สีเดียวกับป้าย — เลือก 'นูน' เพื่อทำตัวอักษรสีที่สอง",
  singleColour: "สีเดียว — พิมพ์ได้ทุกเครื่อง",
  threeMf: (tagName, textName, z, n) => `ไฟล์ 3MF: ป้าย = เส้นที่ 1 (${tagName}), ตัวอักษร = เส้นที่ 2 (${textName}) · เครื่องหัวเดียว: หยุดเปลี่ยนสีที่ Z = ${z} มม. (ชั้นที่ ${n} @0.2 มม.) — ขอบรอบรูจะเป็นสีตัวอักษรด้วย`,

  // ship 3 piece c: the template's static text, baked per language by the build (was hardcoded Thai)
  title: "ป้ายชื่อสัตว์เลี้ยง",
  lineNote: "เปิดในเบราว์เซอร์ปกติเพื่อดาวน์โหลดไฟล์ได้ — แบบที่ทำไว้จะตามไปด้วย",
  lineOpen: "เปิดในเบราว์เซอร์",
  retryNote: "โหลดไม่สำเร็จ — แตะเพื่อโหลดใหม่",
  faceBtn: { front: "หน้า", back: "หลัง" },
  ariaFace: { front: "ด้านหน้า", back: "ด้านหลัง" },
  faceNote: "มองจากด้านหลัง — ข้อความอ่านได้ตามปกติ · ด้านหลังสลักลึก 0.6 มม. เสมอ",
  gTag: "แบบป้าย",
  presetsLabel: "เริ่มจากแบบสำเร็จ",
  ariaPresets: "แบบสำเร็จ",
  templatesLabel: "รูปแบบ",
  ariaTemplates: "รูปแบบ",
  gShape: "รูปทรง",
  shapesLabel: "รูปทรงป้าย",
  ariaShapes: "รูปทรงป้าย",
  sizeLabel: "ขนาดป้าย",
  sizeHint: "เทียบขนาด: เหรียญ 10 บาท = 26 มม.",
  sizeRanges: "แมว/หมาเล็ก 25–30 · หมากลาง 30–38 · หมาใหญ่ 38 มม. ขึ้นไป",
  holeLabel: "รูร้อยห่วง",
  holes: { inside: "เจาะในป้าย", tab: "หูยื่นด้านบน" },
  thickLabel: "ความหนา",
  gColour: "สี",
  modeLabel: "ลายตัวอักษร",
  modes: { raised: "นูน", engraved: "รอยกด" },
  colourLabel: { tag: "สีป้าย", text: "สีตัวอักษร" },
  gAdv: "ปรับตำแหน่งเอง",
  advanced: "ปรับเอง",
  backToSimple: "← กลับโหมดง่าย",
  resetTemplate: "รีเซ็ตเป็นเทมเพลต",
  cancel: "ยกเลิก",
  confirmReset: "ตกลง รีเซ็ต",
  ariaChips: "ชิ้นงานบนป้าย",
  ariaAdd: "เพิ่มชิ้นงาน",
  addText: "＋ ข้อความ",
  ariaSheet: "ปรับชิ้นที่เลือก",
  sheetEmpty: "แตะชิ้นงานบนป้าย หรือแตะชิปด้านบน เพื่อเลือกชิ้นที่จะปรับ",
  emPre: "ขนาด: ",
  mmPost: " มม.",
  nudgePre: "เลื่อน 0.25 มม. · หมุน ",
  nudgePost: "° (แตะ = 15°, กดค้าง = ทีละ 1°)",
  ariaNudge: { left: "เลื่อนซ้าย", up: "เลื่อนขึ้น", down: "เลื่อนลง", right: "เลื่อนขวา" },
  ariaRot: { ccw: "หมุนทวนเข็ม", cw: "หมุนตามเข็ม" },
  deletePiece: "ลบชิ้นนี้",
  aboutH2: "ป้ายห้อยคอหมาแมว ชื่อ + เบอร์โทร พิมพ์ 3 มิติ 2 สี",
  aboutP: "ออกแบบป้ายห้อยคอสำหรับสุนัขและแมว ใส่ชื่อสัตว์เลี้ยงและเบอร์โทรศัพท์ของเจ้าของ เลือกรูปทรง ไอคอน และสีป้าย 2 สี (สีป้าย + สีตัวอักษร) จากเส้นพลาสติกที่หาซื้อได้จริง แล้วดาวน์โหลดไฟล์ 3MF สำหรับเครื่องพิมพ์หลายสี หรือ STL สำหรับพิมพ์สีเดียว ใช้ฟรีในเบราว์เซอร์ ไม่ต้องติดตั้งโปรแกรม",
  printLi1: "พิมพ์ด้วยเส้น PLA หรือ PETG ชั้นความหนา 0.2 มม.",
  printLi2: "พิมพ์ 2 สีด้วยเครื่อง AMS/CFS — ไฟล์ 3MF กำหนดป้ายเป็นเส้นที่ 1 และตัวอักษรนูนเป็นเส้นที่ 2 ไว้ในตัว เลือกสีเส้นจริงที่จะใช้ในโปรแกรมสไลซ์",
  printLi3: "เครื่องพิมพ์หัวเดียว: หยุดเปลี่ยนเส้นที่ความสูง Z ตามค่าที่แจ้งไว้ใต้สีตัวอักษร",
  footerNote: "ป้ายทุกชิ้นผ่านการตรวจวอเตอร์ไทท์ — รูเจาะ + ขอบรอบรูเสริมแรงพร้อมใช้งาน",
  ariaDownloads: "ดาวน์โหลด",
  dlstl: "ดาวน์โหลด STL",
  ariaShareUrl: "ลิงก์ของแบบนี้",
  ariaClose: "ปิด",
  // a link that cannot open (src/doc.js decodeFragment's codes, worded by src/ui/share-ui.js)
  link: {
    bad: "ลิงก์นี้ใช้ไม่ได้ — ลองขอลิงก์ใหม่",
    newer: "ลิงก์นี้มาจากเวอร์ชันใหม่กว่า",
  },
  // What the worker reports, in words (ruling R9: the worker speaks codes, src/worded.js says them) —
  // today's sentences from validate.js, templates.js, generate.js, sanitize.js and geometry.worker.js (R18)
  worker: {
    fontLoad: "โหลดฟอนต์ไม่สำเร็จ — ลองใหม่อีกครั้ง",
    face: {
      front: "ด้านหน้า",
      back: "ด้านหลัง",
    },
    tooDetailed: (face) => `ข้อความ${face}ละเอียดเกินไป — ลองลดตัวอักษรหรือเปลี่ยนฟอนต์`,
    missingChars: (label, chars) => `${label}: ฟอนต์นี้ไม่มีตัวอักษร ${chars}`,
    badChar: (label, point) => `${label}: มีอักขระที่ใช้ไม่ได้ (${point}) — ลบออกแล้วพิมพ์ใหม่`,
    leadingMark: (label) => `${label}เริ่มด้วยสระ/วรรณยุกต์ที่ลอยอยู่ กรุณาใส่พยัญชนะนำหน้า`,
    empty: "ใส่ชื่อสัตว์เลี้ยงก่อนดาวน์โหลด",
    tooMany: (max) => `ใส่ได้ไม่เกิน ${max} ชิ้นต่อด้าน`,
    quoteText: (text) => `"${text}"`,
    quoteIcon: (name) => `ไอคอน${name}`,
    outside: (what) => `${what} ล้นขอบป้าย`,
    onHole: (what) => `${what} ทับรูร้อยห่วง`,
    overlap: (what) => `${what} ชิดหรือทับชิ้นอื่น`,
    tooThin: (what) => `${what} จะเล็กเกินไปจนพิมพ์ออกมาไม่ชัด`,
    tooThinBack: (what, factor) => `${what} เล็กเกินไปสำหรับด้านหลัง (ด้านหลังต้องใหญ่กว่าด้านหน้าราว ${factor} เท่า)`,
    tooThinBackFit: (what) => `${what} จะเล็กเกินไปสำหรับสลักด้านหลัง`,
    tooThinTag: (mm) => `ป้ายบางเกินไปสำหรับสลักด้านหลัง — เพิ่มความหนาเป็น ${mm} มม. ขึ้นไป`,
    holeWall: "ขอบรอบรูร้อยห่วงบางเกินไป — ลองเพิ่มขนาดป้าย หรือเปลี่ยนแบบรู",
    noFit: {
      front: "ข้อความยาวเกินไปสำหรับป้ายขนาดนี้",
      back: "ข้อความด้านหลังยาวเกินไปสำหรับป้ายขนาดนี้",
    },
    wayOut: (why, way) => `${why} — ${way}`,
    way: {
      plain: "ลองเพิ่มขนาดป้าย หรือย่อข้อความ",
      phone: "ลองเพิ่มขนาดป้าย ย่อข้อความ หรือย้ายเบอร์โทรไปด้านหลัง",
    },
    phoneToBack: "ย้ายเบอร์โทรไปด้านหลัง",
  },
  // the name on this page's share card (R69): the page opens with no name, as it always has — the card shows one (today's)
  cardName: "ข้าวปั้น",
};
export default S;
